import React from 'react'
import useStore from "../store";
import strings from "../lang/Localiz";

function ModalBackmove() {
    const infoStation = useStore(state => state.infoStation);
    const closeinfoModalStation = useStore(state => state.closeinfoModalStation);

    let modalSuperPrize = useStore(state => state.modalSuperPrize);
    let dice = useStore(state => state.dice);
    function RandomAnswer2() {
        const random = Math.random();
        if (random < 0.25) {
            return strings.randomText["1"]
        } else if (random < 0.5) {
            return strings.randomText["2"]
        } else if (random < 0.75) {
            return strings.randomText["3"]
        } else {
            return strings.randomText["4"]
        }
    }
    if (infoStation && dice < 0 && !modalSuperPrize) {
        return (
            <div className={"hud-modal"}>
                <div className="close-wrapper" onClick={closeinfoModalStation}></div>
                <div className={"hud-modal-content"}>
                    <div className={"hud-title"}>
                        {
                            dice < 0 ? strings.attention : strings.txt18
                        }

                    </div>
                    <div className={"hud-modal-content-block"}>
                        <div className={"found-txt"}>
                            {
                                RandomAnswer2()
                            }

                        </div>
                        <div onClick={closeinfoModalStation} className={"approve-btn"}>{strings.approve}</div>
                    </div>
                </div>
            </div>

        )
    } else {
        return null
    }
}

export default ModalBackmove;
